class HeaderDrawer extends SideDrawer {
  constructor() {
    super();
    this.moved = true;
    this.header = this.header || document.querySelector('.header-wrapper');
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.classList.add('open-header-drawer');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    }
    window.addEventListener('resize', this.onResize);
    super.open(triggeredBy);
  }

  close() {
    super.close();
    if (this.header) {
      this.header.classList.remove('open-header-drawer');
      document.documentElement.style.removeProperty('--header-bottom-position');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

// if (!customElements.get('menu-details')) {
//   customElements.define('menu-details',
//     class MenuDetails extends HTMLElement {
//       constructor() {
//         super();
//         this.summary.addEventListener('click', this.onSummaryClick.bind(this));
//         this.button.addEventListener('click', this.onButtonClick.bind(this));
//       }

//       get parent() {
//         return this.closest('[data-menu-details-parent]');
//       }

//       get details() {
//         return this.querySelector('details');
//       }

//       get summary() {
//         return this.querySelector('summary');
//       }

//       get button() {
//         return this.querySelector('button');
//       }


//       setMegaMenuOpen() {
//         const megaMenu = this.querySelector('mega-menu');
//         megaMenu?.setAttribute('open', true);
//       }

//       setMegaMenuClose() {
//         const megaMenu = this.querySelector('mega-menu');
//         megaMenu?.removeAttribute('open');
//       }

//       onSummaryClick() {
//         this.setMegaMenuOpen();
//         setTimeout(() => {
//           const parentList = this.closest('.menu-drawer__menu')?.querySelectorAll('summary') || null;
//           console.log(parentList)
//           parentList?.forEach(element => {
//             element.closest('.menu-details').classList.remove('active');
//             element.closest('.menu-details').removeAttribute('open');
//             element.closest('details').removeAttribute('open');
//             element.setAttribute('aria-expanded', false);
//           });
//           this.parent.classList.add('active');
//           this.classList.add('active');
//           this.setAttribute('open', true);
//           this.details.setAttribute('open', true);
//           this.summary.setAttribute('aria-expanded', true);
//         }, 100);
//       }

//       onButtonClick() {
//         this.setMegaMenuClose();
//         this.parent.classList.remove('active');
//         this.classList.remove('active');
//         this.removeAttribute('open');
//         this.details.removeAttribute('open');
//         this.summary.setAttribute('aria-expanded', false);
//       }
//     }
//   )
// }

if (!customElements.get('menu-details')) {
  customElements.define('menu-details',
    class MenuDetails extends HTMLElement {
      constructor() {
        super();

        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.applyHoverBindings = this.applyHoverBindings.bind(this);

        this.summary?.addEventListener('click', this.onSummaryClick);

        this.button?.addEventListener('click', this.onButtonClick.bind(this));

        this.mqDesktop = matchMedia('(min-width: 1366px)');
        // this.mqHover = matchMedia('(hover: hover) and (pointer: fine)');

        this._hoverBound = false;
        this._hoverCloseTimer = null;
        this.HOVER_CLOSE_MS = 300;
      }

      connectedCallback() {
        this.summary?.addEventListener('click', this.onSummaryClick.bind(this));
        this.button?.addEventListener('click', this.onButtonClick.bind(this));

        this.applyHoverBindings();
        this.mqDesktop = matchMedia('(min-width: 1366px)');
        // this.mqHover = matchMedia('(hover: hover) and (pointer: fine)');
        this._onMQ = this.applyHoverBindings.bind(this);
        this.mqDesktop.addEventListener('change', this._onMQ);
        // this.mqHover.addEventListener('change', this._onMQ);
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onSummaryClick);
        this.removeHoverBindings?.();
        this.mqDesktop.removeEventListener('change', this.applyHoverBindings);
        // this.mqHover.removeEventListener('change', this.applyHoverBindings);
      }

      get parent() { return this.closest('[data-menu-details-parent]'); }
      get details() { return this.querySelector('details'); }
      get summary() { return this.querySelector('summary'); }
      get button() { return this.querySelector('button'); }
      get submenu() {
        return this.querySelector('.menu-drawer__submenu');
      }


      setMegaMenuOpen() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.setAttribute('open', true);
      }

      setMegaMenuClose() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.removeAttribute('open');
      }

      onSummaryClick() {
        this.setMegaMenuOpen();
        setTimeout(() => {
          const parentList = this.closest('.menu-drawer__menu')?.querySelectorAll('summary') || null;
          parentList?.forEach(element => {
            element.closest('.menu-details')?.classList.remove('active');
            element.closest('.menu-details')?.removeAttribute('open');
            element.closest('details')?.removeAttribute('open');
            element.setAttribute('aria-expanded', false);
          });
          this.parent?.classList.add('active');
          this.classList.add('active');
          this.setAttribute('open', true);
          this.details?.setAttribute('open', true);
          this.summary?.setAttribute('aria-expanded', true);
        }, 100);
      }

      onButtonClick() {
        this.setMegaMenuClose();
        this.parent?.classList.remove('active');
        this.classList.remove('active');
        this.removeAttribute('open');
        this.details?.removeAttribute('open');
        this.summary?.setAttribute('aria-expanded', false);
      }

      onEnter() {
        if (this._hoverCloseTimer) { clearTimeout(this._hoverCloseTimer); this._hoverCloseTimer = null; }
        this.onSummaryClick();
      }

      onLeave() {
        console.log("chhhh")
        if (this._hoverCloseTimer) clearTimeout(this._hoverCloseTimer);
        this._hoverCloseTimer = setTimeout(() => {
          this.onButtonClick(); 
        }, this.HOVER_CLOSE_MS);
      }

      applyHoverBindings() {
        const useHover = this.mqDesktop.matches ;

        if (useHover && !this._hoverBound) {
          this.summary?.removeEventListener('click', this.onSummaryClick.bind(this));

          this.summary?.addEventListener('mouseenter', this.onEnter.bind(this));
          this.addEventListener('mouseleave', this.onLeave.bind(this));

          this.submenu?.addEventListener('mouseenter', this.onEnter.bind(this));
          this.submenu?.addEventListener('mouseleave', this.onLeave.bind(this));

          this._hoverBound = true;
        } else if (!useHover && this._hoverBound) {
          this.removeHoverBindings();
          this.summary?.addEventListener('click', this.onSummaryClick.bind(this));
          this._hoverBound = false;
        }
      }

      removeHoverBindings() {
        this.summary?.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.submenu?.removeEventListener('mouseenter', this.onEnter);
        this.submenu?.removeEventListener('mouseleave', this.onLeave);
        if (this._hoverCloseTimer) clearTimeout(this._hoverCloseTimer);
      }
    }
  )
}


class SearchModalOpener extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const closeSelector = this.dataset.triggerClose;
    const openSelector = this.dataset.triggerOpen;
    const trigger = event.currentTarget.querySelector('button') || event.currentTarget;

    if (closeSelector) {
      const closeElement = document.querySelector(closeSelector);
      closeElement?.close();
      await new Promise(resolve => requestAnimationFrame(resolve));
      await new Promise(resolve => setTimeout(resolve, 350));
    }

    if (openSelector) {
      const modal = document.querySelector(openSelector);
      if (!modal) return;

      if (typeof modal.open === 'function') {
        modal.open({ target: modal.summaryToggle, relatedTarget: trigger });
      } else {
        modal.querySelector('summary')?.click();
      }
    }
  }
}

customElements.define('search-modal-opener', SearchModalOpener);

document.addEventListener('click', (event) => {
  if (event.target.closest('.list-menu__item--lv3')) {
    document.querySelector('header-drawer')?.close();
  }
})
